<template>
    <popup-modal-confirm
            v-if="mainStore.confirmLeave"
            :message="$t('general.unsaved_changes')"
            :confirmText="$t('general.i_am_sure')"
            @close="mainStore.disableLeaving()"
            @confirm="leave()"
        >
    </popup-modal-confirm>
</template>

<script>
import PopupModalConfirm from './PopupModalConfirm.vue';
import {mapStores} from "pinia";
import {useMainStore} from "../../state/store";

export default {
    components: {
        'popup-modal-confirm': PopupModalConfirm
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        leave () {
            this.mainStore.confirmLeave();
            this.mainStore.disableLeaving();
        }
    }
}
</script>
